<template>
	<div class="abiturient-new-request">
		<template v-if="!submissionMode">
			<v-row>
				<v-breadcrumbs :items="breadcrumbs" divider="/" class="mb-4"></v-breadcrumbs>
			</v-row>
			<div class="faq_area">
				<div class="container">
					<div class="row justify-center">
						<div class="col-lg-12 mb-4">
							<div class="section_title text_center mt-3">
								<div class="section_main_title">
									<h2>{{ $t('Выберите способ подачи заявки') }}</h2>
								</div>
							</div>
						</div>
						<div class="col-lg-5 col-md-6 col-sm-12 my-0 mx-auto">
							<div class="service_style_one text_center pt-40 pb-40 pl-3 pr-3 mb-4" @click="selectAbiturientMode">
								<div class="service_style_one_icon mb-30">
									<i><v-icon size="48" color="primary">mdi-account</v-icon></i>
								</div>
								<div class="service_style_one_title mb-30">
									<h4>{{ $t('Как абитуриент') }}</h4>
								</div>
								<div class="service_style_one_text">
									<p>{{ $t('Подать заявку на поступление от своего имени') }}</p>
								</div>
								<div class="service_style_one_button pt-3">
									<a href="#" @click.prevent="selectAbiturientMode">{{ $t('Продолжить') }} →</a>
								</div>
							</div>
						</div>
						<div class="col-lg-5 col-md-6 col-sm-12 my-0 mx-auto">
							<div class="service_style_one text_center pt-40 pb-40 pl-3 pr-3 mb-4" @click="openGbdflModal">
								<div class="service_style_one_icon mb-30">
									<i><v-icon size="48" color="primary">mdi-account-group</v-icon></i>
								</div>
								<div class="service_style_one_title mb-30">
									<h4>{{ $t('Через ГБДФЛ') }}</h4>
								</div>
								<div class="service_style_one_text">
									<p>{{ $t('Подать заявку на поступление за ребёнка через подтверждение по SMS') }}</p>
								</div>
								<div class="service_style_one_button pt-3">
									<a href="#" @click.prevent="openGbdflModal">{{ $t('Продолжить') }} →</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>

		<template v-else-if="submissionMode === 'abiturient'">
		<v-row>
			<v-breadcrumbs :items="breadcrumbs" divider="/" class="mb-4"></v-breadcrumbs>
		</v-row>
		<v-btn text class="mb-2" @click="submissionMode = null">
			<v-icon left>mdi-arrow-left</v-icon>
			{{ $t('Назад к выбору способа') }}
		</v-btn>
		<v-stepper v-model="step" alt-labels>
			<v-stepper-header>
				<v-stepper-step :complete="step > 1" step="1">{{ $t('Тип заявки') }}</v-stepper-step>
				<v-divider></v-divider>
				<v-stepper-step :complete="step > 1" step="2">{{ $t('Профдиагностика') }}</v-stepper-step>
				<v-divider></v-divider>
				<v-stepper-step :complete="step > 2" step="3">{{ $t('Данные') }}</v-stepper-step>
				<v-divider></v-divider>
				<v-stepper-step :complete="step > 3" step="4">{{ $t('Образование') }}</v-stepper-step>
				<v-divider></v-divider>
				<v-stepper-step :complete="step > 4" step="5">{{ $t('Квота') }}</v-stepper-step>
				<v-divider></v-divider>
				<v-stepper-step :complete="step > 5" step="6">{{ $t('Специальность') }}</v-stepper-step>
			</v-stepper-header>

			<v-stepper-items>
				<v-stepper-content step="1">
					<div v-if="metadataLoading" class="text-center py-8">
						<v-progress-circular indeterminate color="primary"></v-progress-circular>
					</div>
					<template v-else>
						<v-card
							v-for="(item, index) in applicationTypeCards"
							:key="'step1-' + index"
							outlined
							class="mb-4"
						>
							<v-card-text class="text-h6">
								{{ item.title }}<br>
								<div class="blue--text text-darken-3 font-weight-bold">{{ item.subtitle }}</div>
							</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn depressed @click.stop="selectApplicationType(item)">{{ $t('Продолжить') }}</v-btn>
							</v-card-actions>
						</v-card>
					</template>
				</v-stepper-content>

				<v-stepper-content step="2">
					{{ $t('Пройдите профдиагностику на сайте') }} <a href="https://edunavigator.kz/" target="_blank" class="">BTS·Education</a>
					
					<v-checkbox v-model="btsCheckbox" :label="$t('Я получил(а) и ознакомился(ась) с результатами профдиагностики')"></v-checkbox>

					<div class="text-right">
						<v-btn v-if="!requestData.is_undeveloped_place" @click.stop="step--" class="mr-3" elevation="0">{{ $t('Назад') }}</v-btn>
						<v-btn color="primary" @click.stop="step3" :disabled="!btsCheckbox" :loading="isLoading">{{ $t('Далее') }}</v-btn>
					</div>
				</v-stepper-content>

				<v-stepper-content step="3">
					<v-form class="form" ref="formStep3">
						<v-select
							v-if="!usesMetadataApi"
							v-model="requestData.declarant_type_id"
							:items="firstDeclarantType"
							item-text="name"
							item-value="id"
							:rules="[v => !!v || $t('Обязательное поле')]"
							:label="$t('Тип заявителя')">
						</v-select>
						<v-alert
							v-else
							dense
							outlined
							type="info"
							class="mb-4"
						>
							<strong>{{ $t('Тип заявителя') }}:</strong> {{ declarantTypeLabel }}
						</v-alert>
						<template v-if="requestData.declarant_type_id">
							
							<v-card outlined class="mb-4">
								<v-card-title>{{ $t('Данные абитуриента') }}</v-card-title>
								<v-card-text>
									<v-row>
										<v-col sm="3" cols="12">
											<v-text-field
												v-model="requestData.surname"
												:label="$t('Фамилия')"
												type="text"
											></v-text-field>
										</v-col>
										<v-col sm="3" cols="12">
											<v-text-field
												v-model="requestData.name"
												:label="$t('Имя')"
												type="text"
												:rules="[v => !!v || $t('Обязательное поле')]"
												required
											></v-text-field>
										</v-col>
										<v-col sm="3" cols="12">
											<v-text-field
												v-model="requestData.lastname"
												:label="$t('Отчество')"
												type="text"
											></v-text-field>
										</v-col>
										<v-col sm="3" cols="12">
											<v-menu
												v-model="datePickerMenu"
												:close-on-content-click="false"
												:nudge-right="40"
												transition="scale-transition"
												offset-y
												min-width="auto">
												<template v-slot:activator="{ on, attrs }">
													<v-text-field
														v-model="requestData.birthday"
														:label="$t('Дата рождения')"
														:readonly="!isEcpAuth"
														prepend-icon="mdi-calendar"
														:rules="birthdayDateRules"
														required
														v-bind="attrs"
														v-on="on"
													></v-text-field>
												</template>
												<v-date-picker
												v-model="requestData.birthday"
												min="1901-01-01"
												:max="maxBirthdayDate"
												@input="datePickerMenu = false"
												></v-date-picker>
											</v-menu>
										</v-col>
									</v-row>
									<v-row>
										<v-col sm="4" cols="12">
											<v-select
												v-model="requestData.citizen_status_id"
												:items="citizenStatusList"
												item-text="name"
												item-value="id"
												:rules="[v => !!v || $t('Обязательное поле')]"
												:label="$t('Статус гражданина')">
											</v-select>
										</v-col>
										<v-col sm="4" cols="12">
											<v-select
												v-model="requestData.nationality_id"
												:items="nationalityList"
												item-text="name"
												item-value="id"
												:rules="[v => !!v || $t('Обязательное поле')]"
												:label="$t('Национальность')">
											</v-select>
										</v-col>
										<v-col sm="4" cols="12">
											<v-text-field
												v-model="requestData.iin"
												:label="$t('ИИН')"
												type="number"
												:rules="[v => !v || v.match(/\d/g).length === 12 || $t('Неправильный формат ИИН')]"
												@wheel="$event.target.blur()"
											></v-text-field>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>

							<v-card outlined class="mb-4">
								<v-card-title>{{ $t('Контактные данные') }}</v-card-title>
								<v-card-text>
									<v-row>
										<v-col sm="4" cols="12">
											<v-text-field
												v-model="requestData.email"
												:label="$t('Электронная почта')"
												type="text"
												:rules="[v => !!v || $t('Обязательное поле'), v => /.+@.+\..+/.test(v) || $t('Введите корректный E-mail')]"
												required
											></v-text-field>
										</v-col>
										<v-col sm="4" cols="12">
											<v-text-field
												v-model="requestData.phone_number"
												:label="$t('Номер телефона абитуриента')"
												prefix="+"
												type="number"
												@wheel="$event.target.blur()"
												:rules="[v => !!v || $t('Обязательное поле'), v => !v || v.match(/\d/g).length === 11 || $t('Неправильный формат телефона')]"
												required
											></v-text-field>
										</v-col>
										<v-col sm="4" cols="12">
											<v-text-field
												v-model="requestData.parent_phone_number"
												:label="$t('Номер телефона родителя')"
												type="number"
												prefix="+"
												@wheel="$event.target.blur()"
												:rules="[v => !!v || $t('Обязательное поле'), v => !v || v.match(/\d/g).length === 11 || $t('Неправильный формат телефона')]"
												required
											></v-text-field>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>

							<v-card outlined class="mb-4">
								<v-card-title>{{ fileSectionTitle('Медицинские данные') }}</v-card-title>
								<v-card-text>
									<v-row>
										<v-col sm="12" cols="12">
											<v-file-input
													:label="$t('Медицинская справка 075/У (086)')"
													accept="image/*,application/pdf"
													:rules="[requiredFileRule, fileSizeRule]"
													@change="form086ToBase64"
													required >
											</v-file-input>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>

								<v-row>
									<v-col>
										<v-checkbox v-model="requestData.instructionCheck" :label="$t('С Единой инструкцией по проведению Конкурса ознакомлен(-а)')" :rules="[v => !!v || $t('Обязательное поле')]"></v-checkbox>
									</v-col>
									<v-col>
										<v-checkbox v-model="requestData.personalDataCheck" :label="$t('Даю согласие на сбор, обработку персональных данных')" :rules="[v => !!v || $t('Обязательное поле')]"></v-checkbox>
									</v-col>
								</v-row>
						</template>
					</v-form>
					
					<div class="text-right">
						<v-btn v-if="step != 1" @click.stop="step--" class="mr-3" elevation="0">{{ $t('Назад') }}</v-btn>
						<v-btn color="primary" @click.stop="step4" :loading="isLoading">{{ $t('Далее') }}</v-btn>
					</div>
				</v-stepper-content>

				<v-stepper-content step="4">
					<v-form class="form" ref="formStep4">
						<v-select
							v-model="requestData.education_type_id"
							:items="educationTypeList"
							item-text="name"
							item-value="id"
							:readonly="requestData.is_undeveloped_place"
							:rules="[v => !!v || $t('Обязательное поле')]"
							:label="$t('Тип образования')">
						</v-select>

						<template v-if="requestData.education_type_id">
							<v-card outlined class="mb-4" v-if="requestData.education_type_id == 1 || requestData.education_type_id == 2">
								<v-card-title>{{ $t('Данные о школе') }}</v-card-title>
								<v-card-text>

									<v-autocomplete
										v-model="requestData.school_country_id"
										:items="countryList"
										item-text="name"
										item-value="id"
										:label="$t('Страна')"
										clearable
										:rules="[v => !!v || $t('Обязательное поле')]">
									</v-autocomplete>
									<template v-if="requestData.school_country_id == 398">
										<v-select
											v-model="requestData.school_region_ab"
											:items="regionList"
											item-text="name"
											:item-value="schoolRegionItemValue"
											:rules="[v => !!v || $t('Обязательное поле')]"
											:label="$t('Регион')"
											@change="onSchoolRegionChange">
										</v-select>
										<v-autocomplete
												:key="'school-' + requestData.school_region_ab"
												v-model="requestData.school_id"
												:items="schoolList"
												item-text="name"
												item-value="id"
												:label="$t('Школа')"
												clearable
												:rules="[schoolIdRule]">
										</v-autocomplete>
									</template>
									

								</v-card-text>
							</v-card>
							<v-text-field
								v-model="requestData.graduation_year"
								:label="$t('Год окончания')"
								type="text"
								inputmode="numeric"
								maxlength="4"
								@input="onGraduationYearInput"
								:rules="graduationYearRules"
								required
							></v-text-field>
							
							<v-select
								v-model="requestData.education_document_type_id"
								:items="educationDocumentList"
								item-text="name"
								item-value="id"
								:rules="[v => !!v || $t('Обязательное поле')]"
								:label="$t('Тип документа')">
							</v-select>
							
							<v-card outlined class="mb-4">
								<v-card-title>{{ fileSectionTitle('Документ об образовании') }}</v-card-title>
								<v-card-text>
									<v-file-input
										:label="$t('Документ об образовании')"
										accept="image/*,application/pdf"
										:rules="[requiredFileRule, fileSizeRule]"
										@change="educationDocumentToBase64"
										required >
									</v-file-input>
								</v-card-text>
							</v-card>
						</template>
					</v-form>
					<div class="text-right">
						<v-btn v-if="step != 1" @click.stop="step--" class="mr-3" elevation="0">{{ $t('Назад') }}</v-btn>
						<v-btn color="primary" @click.stop="step5" :loading="isLoading">{{ $t('Далее') }}</v-btn>
					</div>
				</v-stepper-content>

				<v-stepper-content step="5">
					<v-form class="form" ref="formStep5">
						<v-select
							v-model="requestData.quota_list[0].id"
							:items="quotaCategoryList"
							@change="quotaCategoryChanged"
							item-text="name"
							item-value="id"
							:rules="[v => !!v || $t('Обязательное поле')]"
							:label="$t('Тип льготы')">
						</v-select>
						<template v-if="requestData.quota_list[0].id && requestData.quota_list[0].id != 0 && requestData.quota_list[0].id != 3">
							<v-card outlined class="mb-4">
								<v-card-title>{{ fileSectionTitle('Документ подтверждающий льготу') }}</v-card-title>
								<v-card-text>
									<v-file-input
										:label="$t('Документ подтверждающий льготу')"
										accept="image/*,application/pdf"
										:rules="[requiredFileRule, fileSizeRule]"
										@change="quotaDocumentToBase64"
										required >
									</v-file-input>
								</v-card-text>
							</v-card>
						</template>
					</v-form>
					<div class="text-right">
						<v-btn v-if="step != 1" @click.stop="step--" class="mr-3" elevation="0">{{ $t('Назад') }}</v-btn>
						<v-btn color="primary" @click.stop="step6" :loading="isLoading">{{ $t('Далее') }}</v-btn>
					</div>
				</v-stepper-content>

				<v-stepper-content step="6">
					<v-form class="form" ref="formStep6">
						<v-select
							v-model="requestData.education_form_id"
							:items="educationFormList"
							@change="clearQualificationList"
							item-text="name"
							item-value="id"
							:readonly="requestData.is_undeveloped_place"
							:rules="[v => !!v || $t('Обязательное поле')]"
							:label="$t('Форма обучения')">
						</v-select>
						<v-select
							v-model="requestData.region_ab"
							:items="regionIsEdusList"
							@change="clearQualificationList"
							item-text="name"
							:item-value="schoolRegionItemValue"
							:readonly="requestData.is_undeveloped_place"
							:rules="[v => !!v || $t('Обязательное поле')]"
							:label="$t('Регион')">
						</v-select>
						<div
							v-if="requestData.region_ab && requestData.education_form_id"
							:key="'qualifications-' + requestData.region_ab + '-' + requestData.education_form_id"
						>
							<v-card outlined class="mb-4" v-for="(item, index) in requestData.choosed_qualification" :key="'qualification-' + index">
								<v-card-text>
									<v-btn fab small depressed text v-if="index != 0" @click.stop="removeQualificationBlock(index)" style="position: absolute; top: 0; right: 0;">
										<v-icon>mdi-close</v-icon>
									</v-btn>
									<v-autocomplete
											v-model="qualificationSelected[index]"
											:items="qualificationList"
											item-value="qualification_code"
											:label="$t('Специальность №')+(index+1)"
											@change="qualificationChanged($event, index)"
											:clearable="!requestData.is_undeveloped_place"
											:filter="customQualificationFilter"
											:readonly="requestData.is_undeveloped_place"
											:rules="[v => !v || Object.keys(v).length != 0 || $t('Обязательное поле')]"
											return-object>
											<template v-slot:item="{ item }">
												<div class="py-3">
													<template v-if="usesMetadataApi">
														{{ item.display_label }}
													</template>
													<template v-else>
														{{item.qualification_code}} ({{item.specialty_code}}) – {{item.name}} ({{item.specialty_name}})
													</template>
												</div>
											</template>
											<template v-slot:selection="{ item }">
											<span style="text-overflow: ellipsis; overflow: hidden; width: 90%; white-space: nowrap; position: absolute;">
												<template v-if="usesMetadataApi">
													{{ item.display_label }}
												</template>
												<template v-else>
													{{item.qualification_code}} ({{item.specialty_code}}) – {{item.name}} ({{item.specialty_name}})
												</template>
											</span>
											</template>
									</v-autocomplete>

									<template v-if="usesMetadataApi">
										<v-select
											v-if="qualificationSelected[index] && qualificationSelected[index].colleges"
											v-model="item.college_id"
											:items="collegeList[index]"
											@change="newApiCollegeChanged(index)"
											item-text="name"
											item-value="college_id"
											:readonly="requestData.is_undeveloped_place"
											:rules="[v => !!v || $t('Обязательное поле')]"
											:label="$t('Организация образования')">
										</v-select>
										<v-select
											v-if="item.college_id"
											v-model="item.lang"
											:items="collegeLangList[index]"
											item-text="name"
											item-value="lang_short"
											:readonly="requestData.is_undeveloped_place"
											:rules="[v => !!v || $t('Обязательное поле')]"
											:label="$t('Язык обучения')">
										</v-select>
									</template>
									<template v-else>
										<v-select
											v-model="item.bin"
											:items="collegeList[index]"
											@change="collegeChanged(index)"
											item-text="name"
											item-value="college_bin"
											:readonly="requestData.is_undeveloped_place"
											:rules="[v => !!v || $t('Обязательное поле')]"
											:label="$t('Организация образования')">
										</v-select>
										<v-select
											v-model="item.lang"
											:items="collegeLangList[index]"
											@change="languageChanged(index)"
											item-text="name"
											item-value="lang_short"
											:readonly="requestData.is_undeveloped_place"
											:rules="[v => !!v || $t('Обязательное поле')]"
											:label="$t('Язык обучения')">
										</v-select>

										<v-checkbox
											v-if="collegeTargetGrantList[index]"
											v-model="item.target_grant"
											:label="$t('Хочу участвовать в целевом гранте')"
										></v-checkbox>
									</template>
								</v-card-text>
							</v-card>
							<v-btn color="primary" @click.stop="addQualificationBlock" v-if="requestData.payment_type_id == 2 && requestData.training_type_id == 1 && maxChoosedQualificationCoun > requestData.choosed_qualification.length && !requestData.is_undeveloped_place">
								{{ $t('Добавить еще одну специальность') }}
							</v-btn>
						</div>

						<v-divider class="my-4"></v-divider>
						<sign-ecp
							@update-ecp-file-data="requestData.p12 = $event"
							@update-ecp-password="requestData.password = $event"
						/>
					</v-form>
					<div class="text-right">
						<v-btn v-if="step != 1" @click.stop="step--" class="mr-3" elevation="0" :loading="isLoading">{{ $t('Назад') }}</v-btn>
						<v-btn color="primary" @click.stop="submitRequest" :loading="isLoading">{{ $t('Отправить') }}</v-btn>
					</div>
				</v-stepper-content>

			
			</v-stepper-items>
		</v-stepper>
		</template>

		<v-dialog v-model="gbdflDialog" max-width="400">
			<v-card style="padding: 1rem 0.5rem;">
				<v-btn icon style="position: absolute; top: 0; right: 0;" @click="closeGbdflModal">
					<v-icon>mdi-close</v-icon>
				</v-btn>
				<v-card-title class="text-h6">
					{{ $t('Подтверждение по SMS') }}
				</v-card-title>
				<v-card-text>
					<p>{{ $t('Мы отправили вам сообщение для подтверждения вашей личности. После подтверждения, нажмите на кнопку "Обновить".') }}</p>
					<p v-if="gbdflNotification" class="error-message">{{ gbdflNotification }}</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="closeGbdflModal">{{ $t('Отмена') }}</v-btn>
					<v-btn @click="updateConfirm" color="primary" :loading="gbdflLoading">
						{{ $t('Обновить') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import {
		mapMetadataToSelectItems,
		getMetadataLabel,
		buildStep1ApplicationTypes,
		buildDefaultEducationRelations,
		mapRelationsDocuments,
		normalizeRegions,
		mapQualificationApiResponse,
		buildQualificationFormBody,
		mapCollegeLangOptions,
	} from '@/utils/metadata';
	import { formatSchoolList } from '@/utils/format';
	import { buildAddOrderFormData, createBirthdayDateRules, formatMaxBirthdayDate } from '@/utils/orderForm';
	import { buildFileSectionTitle, createFileSizeRule } from '@/utils/fileUpload';

	export default {
		computed: {
			usesMetadataApi() {
				return this.$store.getters.usesAbiturientNewApi && this.metadataLoaded;
			},
			isEcpAuth() {
				return this.$store.getters.getAuthMethod === 'ecp';
			},
			applicationTypeCards() {
				return buildStep1ApplicationTypes(this.metadata);
			},
			declarantTypeLabel() {
				return getMetadataLabel(this.metadata.declarant_type, this.requestData.declarant_type_id)
					|| this.$t('Поступающий/Учащийся');
			},
			firstDeclarantType() {
				return this.declarantTypeList.slice(0, 1);
			},
			schoolRegionItemValue() {
				return this.usesMetadataApi ? 'id' : 'ab';
			},
			graduationYearRules() {
				const currentYear = new Date().getFullYear();
				return [
					(v) => !!v || this.$t('Обязательное поле'),
					(v) => !v || /^\d{4}$/.test(String(v)) || this.$t('Неправильный формат'),
					(v) => !v || Number(v) >= 1901 || this.$t('Год не может быть меньше 1901'),
					(v) => !v || Number(v) <= currentYear || this.$t('Год не может быть больше текущего'),
				];
			},
			birthdayDateRules() {
				return createBirthdayDateRules((key) => this.$t(key));
			},
			maxBirthdayDate() {
				return formatMaxBirthdayDate();
			},
			breadcrumbs() {
				return [
					{
						text: this.$t('Главная'),
						disabled: false,
						exact: true,
						to: '/abiturient',
					},
					{
						text: this.$t('Мои заявки'),
						disabled: false,
						exact: true,
						to: '/abiturient/my-requests',
					},
					{
						text: this.$t('Новая заявка'),
						disabled: true,
						exact: true,
						to: '',
					}
				];
			}
		},
		mounted() {
			if(+this.$route.query.is_undeveloped_place === 1) {
				this.submissionMode = 'abiturient';
				this.requestData.is_undeveloped_place = true;
				this.requestData.training_type_id = this.$route.query.training_type_id;
				this.requestData.payment_type_id = this.$route.query.payment_type_id;
				this.requestData.education_type_id = this.$route.query.education_type_id;
				this.requestData.education_form_id = this.$route.query.education_form_id;
				this.requestData.region_ab = this.$route.query.region_ab;
				this.clearQualificationList();
				this.qualificationSelected[0] = this.$route.query.qualification_code;
				this.requestData.choosed_qualification[0] = {
							'code': this.$route.query.qualification_code,
							'specialty_code': this.$route.query.specialty_code,
							'bin': this.$route.query.college_bin,
							'lang': this.$route.query.lang_short
						};
				this.getCollege(0);
				this.getCollegeLang(0);
				this.step++;
			}
		},
		data () {
			return {
				submissionMode: null,
				metadata: null,
				metadataLoaded: false,
				metadataLoading: false,
				gbdflDialog: false,
				gbdflNotification: '',
				gbdflLoading: false,
				postGbdflList: [],
				isLoading: false,
				step: 1,
				btsCheckbox: false,
				declarantTypeList: [],
				citizenStatusList: [],
				educationTypeList: [],
				nationalityList: [],
				datePickerMenu: false,
				countryList: [],
				regionList: [],
				regionIsEdusList: [],
				schoolList: [],
				educationDocumentList: [],
				educationRelations: [],
				relationsLoaded: false,
				quotaCategoryList: [],
				educationFormList: [],
				qualificationList: [],
				qualificationSelected: [],
				collegeList: [],
				collegeLangList: [],
				collegeTargetGrantList: [],
				choosedQualificationItem: {
					"specialty_code": null,
					"code": null,
					"bin": null,
					"lang": null,
					"college_id": null,
				},
				maxChoosedQualificationCoun: 4,
				form086File: null,
				educationDocumentFile: null,
				quotaDocumentFile: null,

				requestData: {
					training_type_id: null,
					payment_type_id: null,
					declarant_type_id: null,
					citizen_status_id: null,
					surname: null,
					name: null,
					lastname: null,
					iin: null,
					birthday: null,
					email: null,
					phone_number: null,
					parent_phone_number: null,
					nationality_id: null,
					graduation_year: null,
					education_type_id: null,
					school_country_id: 398,
					school_region_ab: null,
					school_id: null,
					education_document_type_id: null,
					education_document: null,
					is_have_quota: null, // TODO
					quota_list: [
						{
							"id": null,
							"document": null
						}
					],
					region_ab: null,
					education_form_id: null,
					choosed_qualification: [],
					p12: null,
					password: null,
					is_undeveloped_place: false
				}
			}
		},
		methods: {
			requiredFileRule(value) {
				return !!value || this.$t('Обязательное поле');
			},
			fileSectionTitle(titleKey) {
				return buildFileSectionTitle((key) => this.$t(key), titleKey);
			},
			fileSizeRule(file) {
				return createFileSizeRule((key) => this.$t(key))(file);
			},
			onGraduationYearInput(value) {
				const digits = String(value || '').replace(/\D/g, '').slice(0, 4);
				this.requestData.graduation_year = digits === '' ? null : digits;
			},
			schoolIdRule(v) {
				if (v === 0 || v === '0' || v) {
					return true;
				}
				return this.$t('Обязательное поле');
			},
			async selectAbiturientMode() {
				this.submissionMode = 'abiturient';
				await this.loadMetadata();
			},
			selectApplicationType(item) {
				this.requestData.training_type_id = item.training_type_id;
				this.requestData.payment_type_id = item.payment_type_id;
				this.step++;
			},
			async loadMetadata(force = false) {
				if (this.metadataLoaded && !force) {
					return;
				}
				this.metadataLoading = true;
				try {
					const response = await this.$http.get('/metadata');
					this.metadata = response.data.data || response.data;
					this.metadataLoaded = true;
					this.applyMetadataLists();
				} catch (error) {
					console.error('Ошибка загрузки metadata:', error);
				} finally {
					this.metadataLoading = false;
				}
			},
			async reloadMetadataOnLanguageChange() {
				if (this.submissionMode !== 'abiturient') {
					return;
				}
				this.metadataLoaded = false;
				this.metadata = null;
				await this.loadMetadata(true);
			},
			async reloadLocalizedListsOnLanguageChange() {
				await this.reloadMetadataOnLanguageChange();
				if (this.countryList.length) {
					this.countryList = [];
					await this.getCountry(true);
				}
				if (this.relationsLoaded) {
					this.relationsLoaded = false;
					this.educationRelations = [];
					await this.loadRelations(true);
					this.applyEducationDocumentsFromRelations();
				}
				if (this.nationalityList.length) {
					this.nationalityList = [];
					await this.getNationality(true);
				}
				if (this.regionList.length) {
					this.regionList = [];
					await this.getRegion(true);
				}
				if (this.requestData.school_region_ab) {
					await this.getSchool();
				}
				if (this.regionIsEdusList.length) {
					this.regionIsEdusList = [];
					await this.getRegionIsEdus(true);
				}
				if (this.qualificationList.length) {
					await this.getQualification();
				}
			},
			applyMetadataLists() {
				if (!this.metadata) {
					return;
				}
				this.citizenStatusList = mapMetadataToSelectItems(this.metadata.citizen_status);
				this.declarantTypeList = mapMetadataToSelectItems(this.metadata.declarant_type);
				this.educationTypeList = mapMetadataToSelectItems(this.metadata.education_type);
				this.educationFormList = mapMetadataToSelectItems(this.metadata.education_form);
			},
			async loadRelations(force = false) {
				if (this.relationsLoaded && !force) {
					return;
				}
				try {
					const response = await this.$http.get('/relations', { silent: true });
					const data = response.data.data || response.data;
					this.educationRelations = Array.isArray(data) ? data : [];
				} catch (error) {
					console.error('Ошибка загрузки relations:', error);
					this.educationRelations = buildDefaultEducationRelations(this.metadata);
				}
				this.relationsLoaded = true;
			},
			applyEducationDocumentsFromRelations() {
				this.educationDocumentList = mapRelationsDocuments(
					this.educationRelations,
					this.requestData.education_type_id
				);
				if (this.requestData.education_document_type_id) {
					const isValid = this.educationDocumentList.some(
						(item) => item.id === this.requestData.education_document_type_id
					);
					if (!isValid) {
						this.requestData.education_document_type_id = null;
					}
				}
			},
			applyAbiturientDefaults() {
				const info = this.$store.getters.getAbiturientInfo || {};
				if (!this.requestData.surname && info.surname) {
					this.requestData.surname = info.surname;
				}
				if (!this.requestData.name && info.name) {
					this.requestData.name = info.name;
				}
				if (!this.requestData.lastname && info.lastname) {
					this.requestData.lastname = info.lastname;
				}
				if (!this.requestData.birthday && (info.birthDate || info.birthday)) {
					this.requestData.birthday = info.birthDate || info.birthday;
				}
				if (!this.requestData.iin && info.iin) {
					this.requestData.iin = info.iin;
				}
				if (!this.requestData.email && info.email) {
					this.requestData.email = info.email;
				}
			},
			prepareStep3() {
				if (this.usesMetadataApi) {
					if (this.requestData.declarant_type_id == null) {
						this.requestData.declarant_type_id = 1;
					}
					this.applyAbiturientDefaults();
					return;
				}
			},
			async postGbdfl() {
				this.gbdflLoading = true;
				try {
					const response = await this.$http.get('/gbdfl');
					this.postGbdflList = response.data.data;
					this.$store.commit('setGbdflData', this.postGbdflList);
				} catch (error) {
					console.error('Ошибка при отправке запроса на /gbdfl:', error);
				} finally {
					this.gbdflLoading = false;
				}
			},
			async openGbdflModal() {
				this.gbdflDialog = true;
				this.gbdflNotification = '';
				await this.postGbdfl();
			},
			closeGbdflModal() {
				this.gbdflDialog = false;
				this.gbdflNotification = '';
			},
			async updateConfirm() {
				this.gbdflNotification = '';
				await this.postGbdfl();
				if (Array.isArray(this.postGbdflList) && this.postGbdflList.length > 0) {
					this.gbdflDialog = false;
					this.$router.push({ name: 'abiturient-children' });
				} else if (this.postGbdflList === true) {
					this.gbdflNotification = this.$t('К сожалению, произошла ошибка при подтверждении вашей личности. Пожалуйста, попробуйте еще раз. Если проблема сохраняется, свяжитесь с поддержкой.');
				} else if (this.postGbdflList === null) {
					this.gbdflNotification = this.$t('Данные о детях, достигших выпускного возраста, отсутствуют в базе.');
				}
			},
			async step3() {
				if (this.usesMetadataApi) {
					this.prepareStep3();
					await this.getNationality();
					this.step++;
					return;
				}
				await this.getDeclarantType();
				await this.getCitizenStatus();
				await this.getNationality();
				this.step++;
			},
			async step4() {
				if(this.$refs.formStep3.validate()) {
					if (this.usesMetadataApi) {
						await this.loadRelations();
						this.applyEducationDocumentsFromRelations();
					} else {
						await this.getEducationType();
					}
					this.step++;
				}
			},
			async step5() {
				if(this.$refs.formStep4.validate()) {
					await this.getQuotaCategory();
					this.step++;
				}
			},
			async step6() {
				if(this.$refs.formStep5.validate()) {
					this.getEducationForm();
					this.getRegionIsEdus();
					this.step++;
				}
			}, 

			async getDeclarantType() {
				if(!this.declarantTypeList.length) {
					this.isLoading = true;
					await this.$http.get('/declarantType').then((response) => {
						this.declarantTypeList = response.data.data;
					});
					this.isLoading = false;
				}
			},
			async getCitizenStatus() {
				if(!this.citizenStatusList.length) {
					this.isLoading = true;
					await this.$http.get('/citizenStatus').then((response) => {
						this.citizenStatusList = response.data.data;
					});
					this.isLoading = false;
				}
			},
			async getNationality(force = false) {
				if (this.nationalityList.length && !force) {
					return;
				}
				this.isLoading = true;
				try {
					const response = await this.$http.get('/nationality');
					const data = response.data.data || response.data;
					this.nationalityList = Array.isArray(data) ? data : [];
				} finally {
					this.isLoading = false;
				}
			},
			async getEducationType() {
				if(!this.educationTypeList.length) {
					this.isLoading = true;
					await this.$http.get('/educationType').then((response) => {
						this.educationTypeList = response.data.data;
					});
					this.isLoading = false;
				}
			},
			async getCountry(force = false) {
				if (this.countryList.length && !force) {
					return;
				}
				this.isLoading = true;
				try {
					const response = await this.$http.get('/country');
					const data = response.data.data || response.data;
					this.countryList = Array.isArray(data) ? data : [];
				} finally {
					this.isLoading = false;
				}
			},
			async getRegion(force = false) {
				if (this.regionList.length && !force) {
					return;
				}
				this.isLoading = true;
				try {
					if (this.usesMetadataApi) {
						const response = await this.$http.get('/regions');
						const data = response.data.data || response.data;
						this.regionList = Array.isArray(data) ? data : [];
					} else {
						const response = await this.$http.post('/region', {
							country_id: 398,
						});
						this.regionList = response.data.data;
					}
				} finally {
					this.isLoading = false;
				}
			},
			async getRegionIsEdus(force = false) {
				if (this.regionIsEdusList.length && !force) {
					return;
				}
				this.isLoading = true;
				try {
					if (this.usesMetadataApi) {
						const response = await this.$http.get('/regions');
						const data = response.data.data || response.data;
						this.regionIsEdusList = normalizeRegions(data);
					} else {
						const response = await this.$http.post('/region', {
							country_id: 398,
							is_edus: true,
						});
						this.regionIsEdusList = normalizeRegions(response.data.data);
					}
				} finally {
					this.isLoading = false;
				}
			},
			onSchoolRegionChange() {
				this.requestData.school_id = null;
				this.schoolList = [];
				this.getSchool();
			},
			async getSchool() {
				const regionId = this.requestData.school_region_ab;
				if (!regionId) {
					this.schoolList = [];
					return;
				}
				this.isLoading = true;
				try {
					let schools = [];
					if (this.usesMetadataApi) {
						const body = new URLSearchParams();
						body.append('id', regionId);
						const response = await this.$http.post('/schools', body);
						const data = response.data.data || response.data;
						schools = formatSchoolList(data);
					} else {
						const response = await this.$http.post('/school', {
							region_ab: regionId,
						});
						schools = formatSchoolList(response.data.data);
					}
					if (this.requestData.school_region_ab !== regionId) {
						return;
					}
					this.schoolList = schools;
					this.schoolList.push({
						id: '0',
						name: this.$t('Другое'),
					});
					if (this.schoolList.length === 1) {
						this.requestData.school_id = '0';
					}
				} catch (error) {
					if (this.requestData.school_region_ab === regionId) {
						this.schoolList = [];
					}
					console.error('Ошибка загрузки школ:', error);
				} finally {
					if (this.requestData.school_region_ab === regionId) {
						this.isLoading = false;
					}
				}
			},
			async getEducationDocument() {
				if (this.usesMetadataApi) {
					await this.loadRelations();
					this.applyEducationDocumentsFromRelations();
					return;
				}
				this.isLoading = true;
				await this.$http.post('/educationDocument', {
					"education_type_id": this.requestData.education_type_id
				}).then((response) => {
					this.educationDocumentList = response.data.data;
				});
				this.isLoading = false;
			},
			async getQuotaCategory() {
				if(!this.quotaCategoryList.length) {
					this.isLoading = true;
					await this.$http.get('/quota').then((response) => {
						this.quotaCategoryList = response.data.data;
						this.quotaCategoryList.unshift({
							"id": "0",
							"name": this.$t('Без льготы')
						});
					});
					this.isLoading = false;
				}
			},
			quotaCategoryChanged(v) {
				this.requestData.is_have_quota = v != 0;
				if(v == 0) {
					this.requestData.quota_list[0].document = null;
				}
			},
			async getEducationForm() {
				if(!this.educationFormList.length) {
					this.isLoading = true;
					await this.$http.get('/educationForm').then((response) => {
						this.educationFormList = response.data.data;
					});
					this.isLoading = false;
				}
			},

			clearQualificationList() {
				this.requestData.choosed_qualification = [];
				this.qualificationSelected = [];
				this.qualificationList = [];
				this.collegeList = [];
				this.collegeLangList = [];
				this.collegeTargetGrantList = [];
				this.addQualificationBlock();
				if(this.requestData.education_form_id && this.requestData.region_ab) {
					this.getQualification();
				}
			},
			addQualificationBlock() {
				this.qualificationSelected.push({});
				this.requestData.choosed_qualification.push(Object.assign({}, this.choosedQualificationItem));
			},
			customQualificationFilter(item, queryText) {
				const searchText = queryText.toLowerCase();
				if (this.usesMetadataApi) {
					const displayLabel = (item.display_label || '').toLowerCase();
					const name = (item.name || '').toLowerCase();
					const qualificationCode = (item.qualification_code || '').toLowerCase();
					const specialtyCode = (item.specialty_code || '').toLowerCase();
					return displayLabel.includes(searchText)
						|| name.includes(searchText)
						|| qualificationCode.includes(searchText)
						|| specialtyCode.includes(searchText);
				}
				const qualificationCode = (item.qualification_code || '').toLowerCase();
				const specialtyCode = (item.specialty_code || '').toLowerCase();
				const specialtyName = (item.specialty_name || '').toLowerCase();
				const name = (item.name || '').toLowerCase();
				return qualificationCode.includes(searchText)
					|| specialtyCode.includes(searchText)
					|| specialtyName.includes(searchText)
					|| name.includes(searchText);
			},
			removeQualificationBlock(index) {
				this.requestData.choosed_qualification.splice(index, 1); 
			},
			async getQualification() {
				const regionAb = this.requestData.region_ab;
				const educationFormId = this.requestData.education_form_id;
				if (!regionAb || !educationFormId) {
					this.qualificationList = [];
					return;
				}
				this.isLoading = true;
				try {
					let qualifications = [];
					if (this.usesMetadataApi) {
						const body = buildQualificationFormBody(this.requestData);
						const response = await this.$http.post('/qualification', body, {
							headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
						});
						const data = response.data.data || response.data;
						qualifications = mapQualificationApiResponse(data);
					} else {
						const response = await this.$http.post('/qualification', {
							region_ab: regionAb,
							training_type_id: this.requestData.training_type_id,
							education_form_id: educationFormId,
							education_type_id: this.requestData.education_type_id,
							payment_type_id: this.requestData.payment_type_id,
						});
						qualifications = response.data.data;
					}
					if (this.requestData.region_ab !== regionAb
						|| this.requestData.education_form_id !== educationFormId) {
						return;
					}
					this.qualificationList = qualifications;
				} catch (error) {
					if (this.requestData.region_ab === regionAb
						&& this.requestData.education_form_id === educationFormId) {
						this.qualificationList = [];
					}
					console.error('Ошибка загрузки специальностей:', error);
				} finally {
					if (this.requestData.region_ab === regionAb
						&& this.requestData.education_form_id === educationFormId) {
						this.isLoading = false;
					}
				}
			},
			qualificationChanged(item, index) {
				this.requestData.choosed_qualification[index].bin = null;
				this.requestData.choosed_qualification[index].college_id = null;
				this.requestData.choosed_qualification[index].lang = null;
				this.collegeList[index] = [];
				this.collegeLangList[index] = [];
				if (!item) {
					return;
				}
				this.requestData.choosed_qualification[index].specialty_code = item.specialty_code || '';
				this.requestData.choosed_qualification[index].code = item.qualification_code;
				if (this.usesMetadataApi) {
					this.collegeList[index] = item.colleges || [];
					if (item.colleges && item.colleges.length === 1) {
						this.requestData.choosed_qualification[index].college_id = item.colleges[0].college_id;
						this.newApiCollegeChanged(index);
					}
					return;
				}
				this.getCollege(index);
			},
			newApiCollegeChanged(index) {
				const selected = this.qualificationSelected[index];
				const collegeId = this.requestData.choosed_qualification[index].college_id;
				this.requestData.choosed_qualification[index].lang = null;
				this.requestData.choosed_qualification[index].bin = null;
				if (!selected || !collegeId) {
					this.collegeLangList[index] = [];
					return;
				}
				const college = (selected.colleges || []).find((c) => c.college_id === collegeId);
				if (!college) {
					this.collegeLangList[index] = [];
					return;
				}
				this.requestData.choosed_qualification[index].bin = college.college_id;
				this.collegeLangList[index] = mapCollegeLangOptions(college.lang, this.metadata);
				if (college.lang && college.lang.length === 1) {
					this.requestData.choosed_qualification[index].lang = college.lang[0];
				}
			},
			async getCollege(index) {
				this.isLoading = true;
				await this.$http.post('/college', {
					"region_ab": this.requestData.region_ab,
					"qualification_code": this.requestData.choosed_qualification[index].code,
					"training_type_id": this.requestData.training_type_id,
					"education_form_id": this.requestData.education_form_id,
					"education_type_id": this.requestData.education_type_id,
					"payment_type_id": this.requestData.payment_type_id,
				}).then((response) => {
					this.collegeList[index] = response.data.data;
				});
				this.isLoading = false;
			},
			collegeChanged(index) {
				this.requestData.choosed_qualification[index].lang = null;
				this.getCollegeLang(index);
			},
			async getCollegeLang(index) {
				this.isLoading = true;
				await this.$http.post('/lang', {
					"region_ab": this.requestData.region_ab,
					"qualification_code": this.requestData.choosed_qualification[index].code,
					"college_bin": this.requestData.choosed_qualification[index].bin,
					"training_type_id": this.requestData.training_type_id,
					"education_form_id": this.requestData.education_form_id,
					"education_type_id": this.requestData.education_type_id,
					"payment_type_id": this.requestData.payment_type_id
				}).then((response) => {
					this.collegeLangList[index] = response.data.data;
				});
				this.isLoading = false;
			},
			languageChanged(index) {
				this.requestData.choosed_qualification[index].target_grant = false;
				this.getTargetGrant(index);
			},
			async getTargetGrant(index) {
				this.isLoading = true;
				await this.$http.post('/targetGrant', {
					"region_ab": this.requestData.region_ab,
					"qualification_code": this.requestData.choosed_qualification[index].code,
					"college_bin": this.requestData.choosed_qualification[index].bin,
					"training_type_id": this.requestData.training_type_id,
					"education_form_id": this.requestData.education_form_id,
					"education_type_id": this.requestData.education_type_id,
					"payment_type_id": this.requestData.payment_type_id,
					"lang_short": this.requestData.choosed_qualification[index].lang
				}).then((response) => {
					this.collegeTargetGrantList[index] = response.data.data.is_have;
				});
				this.isLoading = false;
			},
			form086ToBase64(file) {
				this.form086File = file || null;
				if (this.usesMetadataApi) {
					return;
				}
				if (file) {
					this.toBase64(file).then((response) => {
						this.requestData.form_086_document = response;
					});
				}
				this.requestData.form_086 = null;
			},
			educationDocumentToBase64(file) {
				this.educationDocumentFile = file || null;
				if (this.usesMetadataApi) {
					return;
				}
				if (file) {
					this.toBase64(file).then((response) => {
						this.requestData.education_document = response;
					});
				}
				this.requestData.education_document = null;
			},
			quotaDocumentToBase64(file) {
				this.quotaDocumentFile = file || null;
				if (this.usesMetadataApi) {
					return;
				}
				if (file) {
					this.toBase64(file).then((response) => {
						this.requestData.quota_list[0].document = response;
					});
				}
				this.requestData.quota_list[0].document = null;
			},
			async toBase64(file) {
				return new Promise((resolve) => {
					const reader = new FileReader();
					reader.readAsDataURL(file);
					reader.onload = () => {
						let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
						if ((encoded.length % 4) > 0) {
							encoded += '='.repeat(4 - (encoded.length % 4));
						}
						resolve(encoded);
					};
				});
			},
			async submitRequest() {
				if (!this.$refs.formStep6.validate()) {
					return;
				}
				this.isLoading = true;
				try {
					if (this.usesMetadataApi) {
						const formData = buildAddOrderFormData(
							this.requestData,
							this.qualificationSelected,
							{
								form086File: this.form086File,
								educationDocumentFile: this.educationDocumentFile,
								quotaDocumentFile: this.quotaDocumentFile,
							},
							{ regionList: this.regionList },
						);
						const response = await this.$http.post('/add-order', formData);
						const message = response.data.message || this.$t('Заявка успешно отправлена');
						this.$store.dispatch('alertAdd', { text: message, type: 'success' });
						this.$router.push({ path: '/abiturient/my-requests' });
						return;
					}
					const response = await this.$http.post('/request', this.requestData);
					this.$store.dispatch('alertAdd', { text: this.$t('Заявка успешно отправлена'), type: 'success' });
					this.$router.push({ path: '/abiturient/my-requests/' + response.data.data.id });
				} finally {
					this.isLoading = false;
				}
			}
		},
		watch: {
			'$store.state.language': function () {
				this.reloadLocalizedListsOnLanguageChange();
			},
			'requestData.training_type_id': function () {
				if(!this.requestData.is_undeveloped_place) {
					this.requestData.education_form_id = null;
					this.requestData.region_ab = null;

					this.clearQualificationList();
				}
			},
			'requestData.payment_type_id': function () {
				if(!this.requestData.is_undeveloped_place) {
					this.clearQualificationList();
				}
			},
			'requestData.declarant_type_id': function (v) {
				console.log(v);
				
				if(v == 1) {
					this.requestData.surname = this.$store.getters.getAbiturientInfo.surname || '';
					this.requestData.name = this.$store.getters.getAbiturientInfo.name || '';
					this.requestData.lastname = this.$store.getters.getAbiturientInfo.lastname || '';
					this.requestData.birthday = this.$store.getters.getAbiturientInfo.birthDate || '';
					this.requestData.iin = this.$store.getters.getAbiturientInfo.iin || '';
					this.requestData.email = this.$store.getters.getAbiturientInfo.email || '';
				}
			},
			'requestData.education_type_id': function (v) {
				if(v == 1 || v == 2) {
					if (!this.requestData.school_country_id) {
						this.requestData.school_country_id = 398;
					}
					this.getCountry();
					this.getRegion();
				} else {
					this.requestData.school_region_ab = null;
					this.requestData.school_id = null;
				}
				this.requestData.education_document_type_id = null;
				this.getEducationDocument();

				if(!this.requestData.is_undeveloped_place) {
					this.clearQualificationList();
				}
			},
			'requestData.school_country_id': function (v) {
				if(v != 398) {
					this.requestData.school_region_ab = null;
					this.requestData.school_id = null;
				}
			},
			'requestData.school_region_ab': function () {
				this.onSchoolRegionChange();
			},
		}
	}
</script>

<style scoped src="@/assets/css/abiturient.css"></style>
<style scoped src="@/assets/css/abiturient/NewRequestView.css"></style>